<template>
  <b-card
    no-body
    class="overflow-hidden"
    style="max-width: 540px; min-height: 150px; position: relative"
  >
    <feather-icon
      @click="$emit('close')"
      class="card-close-btn"
      icon="XIcon"
      size="18"
    />
    <b-spinner
      variant="info"
      v-if="loading"
      style="position: absolute; top: 50%; left: 50%"
    ></b-spinner>
    <b-row v-else no-gutters>
      <b-col cols="4">
        <b-card-img :src="ngo.logo" alt="Image" class="rounded-0"></b-card-img>
      </b-col>
      <b-col cols="8">
        <b-card-body :title="ngo.name_ar">
          <div>
            رقم قرار الإشهار :
            <span class="text-primary">{{ ngo.decision_no }}</span>
          </div>
          <template
            v-if="ngo.classifications && ngo.classifications.length > 0"
          >
            التصنيفات :
            <ul>
              <li
                style="list-style-type: disc"
                v-for="classification in ngo.classifications"
                :key="classification.id"
              >
                {{ classification.name_ar }}
              </li>
            </ul>
          </template>
        </b-card-body>
      </b-col>
      <div class="m-50" style="position: absolute; bottom: 0%; left: 0%">
        <router-link :to="`/ngo/${ngo.id}`">
          انتقال <feather-icon icon="ArrowLeftIcon" />
        </router-link>
      </div>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BSpinner,
  BCard,
  BCol,
  BCardBody,
  BCardImg,
  BCardText,
} from "bootstrap-vue";
export default {
  props: {
    ngo: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
  },
  components: {
    BRow,
    BSpinner,
    BCard,
    BCol,
    BCardBody,
    BCardImg,
    BCardText,
  },
};
</script>

<style>
.card-close-btn {
  position: absolute;
  top: 0%;
  right: 0%;
  margin: 0.7rem;
  cursor: pointer;
  z-index: 10;
}
</style>
